import DropDown from '@/components/formFields/DropDown'
import MultiSelect from '@/components/formFields/DropDown/Multiselect'
import InputField from '@/components/formFields/InputField'
import Field from '@/components/formFields/InputField/Field'
import TextArea from '@/components/formFields/TextArea'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const disabledOptions = [
  { value: 1, label: "Active" },
  { value: 2, label: "Inactive" },
]
const sendUsingOptions = [
  { value: 1, label: "Email" },
  { value: 2, label: "SMS" },
]

const ScalationTextFields = ({ scalation, formHandler, isLoading, updateScalation }) => {


  const { t } = useTranslation()
  const { formValues, handleFormValues } = formHandler
  const [sOptions, setSOptions] = useState([])
  const [disabledValue, setDisabledValue] = useState(null)

  const handleSndChange = (label, sOptions) => {
    updateScalation(scalation.id, 'sendVia', sOptions)

    handleFormValues(label, { value: sOptions, isRequired: true, isError: false })
    setSOptions(sOptions)
  }

  const handleDisableChange = (label, sOptions) => {
    updateScalation(scalation.id, 'disabled', sOptions)

    handleFormValues(label, { value: sOptions, isRequired: true, isError: false })
    setDisabledValue(sOptions)
  }


  useEffect(() => {
    let sOptions = []
    if (scalation?.notifyByEmail) {
      sOptions.push({ value: 1, label: "Email" })
    }
    if (scalation?.notifyBySMS) {
      sOptions.push({ value: 2, label: "SMS" })
    }
    handleSndChange("sendVia", sOptions)
  }, [])

  useEffect(() => {
    let sOptions = []
    if (scalation?.notifyByEmail) {
      sOptions.push({ value: 1, label: "Email" })
    }
    if (scalation?.notifyBySMS) {
      sOptions.push({ value: 2, label: "SMS" })
    }
    handleSndChange("sendVia", sOptions)
  }, [])

  useEffect(() => {
    let sIsDisabled = scalation?.isNotificationEnabled ? 1 : 2
    let sOptions = [{ value: sIsDisabled, label: scalation?.disabled ? t("Active") : t("Inactive") }]
    handleDisableChange("disabled", sOptions)

  }, [])

  return (
    <div className="row">
      <Field
        label={"level"}
        name={"level"}
        className="col-lg-6"
        formHandler={formHandler}
        type="number"
        min={1}
        value={scalation?.level}
        defaultValue={scalation?.level}
        setValue={(value) => updateScalation(scalation.id, 'level', value?.value)} />

      <Field
        label={"name"}
        name={"name"}
        lang='any'
        className="col-lg-6"
        formHandler={formHandler}
        value={scalation?.name?.value}
        defaultValue={scalation?.name}
        setValue={(value) => updateScalation(scalation.id, 'name', value?.value)} />

      <Field
        name={"phoneNumber"}
        label={"phoneNumber"}
        lang='any'
        className="col-lg-6"
        formHandler={formHandler}
        value={scalation?.phoneNumber?.value}
        defaultValue={scalation?.phonNumber}
        setValue={(value) => updateScalation(scalation.id, 'phoneNumber', value?.value)} />

      <Field
        name={"email"}
        label={"email"}
        lang='any'
        className="col-lg-6"
        formHandler={formHandler}
        value={scalation?.email?.value}
        defaultValue={scalation?.email}
        setValue={(value) => updateScalation(scalation.id, 'email', value?.value)} />

      <MultiSelect
        isRender label={"disabled"} sOptions={disabledValue} setSOptions={(sValue) => handleDisableChange("disabled", sValue)} isRequired
        isClearable className={"col-lg-6"} isMulti={false} options={disabledOptions.map(item => ({ value: item.value, label: t(item.label) }))} />

      <MultiSelect
        isRender label={"sendVia"} sOptions={sOptions} setSOptions={(sValue) => handleSndChange("sendVia", sValue)} isRequired
        isClearable className={"col-lg-6"} options={sendUsingOptions.map(item => ({ value: item.value, label: t(item.label) }))} />

      <Field
        name={"SLA"}
        label={"SLA"}
        className="col-lg-6"
        isLoading={isLoading}
        formHandler={formHandler}
        value={scalation?.escalateAfterHours}
        defaultValue={scalation?.escalateAfterHours}
        setValue={(value) => updateScalation(scalation.id, 'escalateAfterHours', value?.value)} />

    </div>
  )
};

export default ScalationTextFields;